<template>
  <div class="qr-scanner" :class="{hasError: error}">
    <transition name="blocker">
      <div class="blocker" v-if="loading" />
    </transition>
    <div class="top">
    </div>
    <div class="middle">
      <transition name="fade">
        <div class="scanner-error" v-if="error">
          <div class="title">We could not access your Camera</div>
          If you would like to use the QR scanner, you must give the required permissions.

          <el-button type="default" v-if="canOpenSettings" @click="openSettings">Open settings</el-button>

        </div>
      </transition>
      <transition name="scanner">
        <div class="scanner" v-if="initialized">
          <div class="lt" />
          <div class="rt" />
          <div class="lb" />
          <div class="rb" />
        </div>
      </transition>
    </div>
    <div class="bottom">
      <transition name="scanner-controls">
        <div class="controls" v-if="initialized">
          <el-button :type="lightsOn ? 'primary' : 'default'" @click="toggleLight"><fa icon="lightbulb" /></el-button>
          <el-button type="default" @click="$emit('close')"><fa icon="times" /></el-button>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  data () {
    return {
      loading: true,
      initialized: false,
      lightsOn: false,
      error: false,
      canOpenSettings: false,
      timer: null
    }
  },
  methods: {
    onScan(err, text) {

      if(!text.includes('https://divegas.azurewebsites.net'))
      {
        this.$message.error('Scanned QR is not a Divegas QR')
        
        this.timer = setTimeout(() => {
          this.startScan()
        }, 5000)

        return;
      }

      var url = text.replace('https://divegas.azurewebsites.net', '')
      this.$router.push(url)
    },
    toggleLight () {
      var QRScanner = Vue.cordova.QRScanner

      if(!this.lightsOn) {
        QRScanner.enableLight(function(err, status){
        });
        this.lightsOn = true
      } else {
        QRScanner.disableLight(function(err, status){
        });
        this.lightsOn = false
      }
    },
    startScan () {
      this.loading = true
      document.body.className = 'scanner'
      
      var QRScanner = Vue.cordova.QRScanner
      QRScanner.scan(this.onScan);
      QRScanner.show((status) => {

        if(!status.authorized) {
          this.error = true
          this.canOpenSettings = status.canOpenSettings
          this.loading = false
          return
        } 

        setTimeout(() => {
          this.loading = false
          this.initialized = true
        }, 500)
      });
    },
    stopScan () {
      clearInterval(this.timer)
      var QRScanner = Vue.cordova.QRScanner
      QRScanner.disableLight();
      QRScanner.hide();
      QRScanner.destroy();

      document.body.className = ''
    },
    openSettings () {
      var QRScanner = Vue.cordova.QRScanner
      QRScanner.openSettings();
    }
  },
  mounted () {
    this.startScan()
    this.$emit('loaded')
  },
  destroyed () {
    this.stopScan()
  }
}
</script>

<style lang="scss" scoped>
$border-color: #008fcc;
$border-width: 4px;
$border-style: solid;

.qr-scanner {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex-wrap: wrap;
    flex-direction: column;

    &.hasError {
      background-color: black;
    }

}

.middle {
  width: 100%;
}

.bottom, .top {
  width: 100%;
  flex-grow: 1;
}

.middle, .bottom {
  display: flex;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: row;
}

.controls {
  width: 250px;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  flex-direction: row;
  button {
    width: 60px;
    height: 60px;
    border-radius: 100%;
  }
}

.scanner-error {
  color: white;
  width: 90%;
  text-align: center;
  .title {
    font-size: 20px;
  }
  button {
    margin-top: 15px;
  }
}

.scanner {
  width: 250px;
  height: 250px;
  position: relative;
  .lt, .lb, .rt, .rb {
    position: absolute;
    width: 50px;
    height: 50px;
  }
  .lt {
    border: 0;
    border-top: $border-width $border-color $border-style;
    border-left: $border-width $border-color $border-style;
    top: 0;
    left: 0;
  }
  .rt {
    border: 0;
    border-top: $border-width $border-color $border-style;
    border-right: $border-width $border-color $border-style;
    top: 0;
    right: 0;
  }
  .lb {
    border: 0;
    border-bottom: $border-width $border-color $border-style;
    border-left: $border-width $border-color $border-style;
    left: 0;
    bottom: 0;
  }
  .rb {
    border: 0;
    border-bottom: $border-width $border-color $border-style;
    border-right: $border-width $border-color $border-style;
    right: 0;
    bottom: 0;
  }
}

.blocker {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
}

</style>



// WEBPACK FOOTER //
// src/components/native/QRScanner.vue